import { ReleaseFamily, VersionDescriptor } from '@feedyou/schema'

export function isOfFamily(...families: ReleaseFamily[]) {
  return function isOfFamily(versionDescriptor: VersionDescriptor) {
    return families.some(family => family === versionDescriptor.releaseFamily)
  }
}
